import { useState } from "react";
import { format } from "date-fns";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstanse";
import { TrackingRequest } from "./usePostTrackingList";

// 운송장조회 엑셀 다운로드 — 페이징과 무관하게 현재 검색조건의 전체 결과를 받는다
export const usePostTrackingListExcel = () => {
    const [isDownloading, setIsDownloading] = useState(false);

    const getExcel = async (params: Omit<TrackingRequest, "getPage" | "getPageSize">) => {
        if (isDownloading) return;
        setIsDownloading(true);
        try {
            const response = await axiosInstance.post(enum_api_uri.tracking_list_excel, params, {
                responseType: "blob",
                timeout: 60000, // 기간 검색 시 건수가 많을 수 있어 기본 10초보다 늘림
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `운송장조회_${format(new Date(), "yyyyMMdd")}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("엑셀 다운로드 중 오류 발생:", error);
            alert("엑셀 다운로드 중 오류가 발생했습니다.");
        } finally {
            setIsDownloading(false);
        }
    };

    return { getExcel, isDownloading };
};
